import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TestDescriptionsService {
    // eslint-disable-next-line
    constructor(http) {
        this.http = http;
    }
    getTestDictionary() {
        return this.http.get(environment.api.base + 'tests');
    }
    updateTestDictionary(id, body, name) {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        return this.http.put(environment.api.base + 'tests?id=' + id + '&name=' + name, '"' + body + '"', httpOptions);
    }
}
TestDescriptionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TestDescriptionsService_Factory() { return new TestDescriptionsService(i0.ɵɵinject(i1.HttpClient)); }, token: TestDescriptionsService, providedIn: "root" });
